import { TranslationObject } from '../i18n/translation';

const namespace = 'practicetype.uha';
const translations: TranslationObject = {
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Opprett og rediger aktivitetskrav',
    en: 'Create and edit activity requirements',
  },
  panelTitle: {
    id: `${namespace}.panelTitle`,
    nb: 'Aktivitetskravene',
    en: 'Activity requirements',
  },
  requirementNameLabel: {
    id: `${namespace}.requirementNameLabel`,
    nb: 'Aktivitetskravnavn',
    en: 'Requirement name',
  },
  back: {
    id: `${namespace}.back`,
    nb: 'Til praksistyper',
    en: 'To practice types',
  },
  delete: {
    id: `${namespace}.delete`,
    nb: 'Slett',
    en: 'delete',
  },
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  saveRequirements: {
    id: `${namespace}.saveRequirements`,
    nb: 'Lagre krav',
    en: 'Save requirements',
  },
  deleteDialogTitle: {
    id: `${namespace}.deleteDialogTitle`,
    nb: 'Er du sikker?',
    en: 'Are you sure?',
  },
  deleteDialogContent: {
    id: `${namespace}.deleteDialogContent`,
    nb: 'Vil du slette aktivitetskrav?',
    en: 'Do you want to delete activity requirement?',
  },
  newRequirement: {
    id: `${namespace}.newRequirement`,
    nb: 'Opprett ny',
    en: 'Create new',
  },
  editRequirementName: {
    id: `${namespace}.editRequirementName`,
    nb: 'Endre navn',
    en: 'Change name',
  },
  successNewRequirement: {
    id: `${namespace}.successNewRequirement`,
    nb: 'Aktivitetskrav opprettet',
    en: 'Requirement created',
  },
  successRequirementsSaved: {
    id: `${namespace}.successSaveRequirement`,
    nb: 'Aktivitetskrav lagret',
    en: 'Activity requirements saved',
  },
  successDelete: {
    id: `${namespace}.successDelete`,
    nb: 'Aktivitetskrav slettet',
    en: 'Requirement deleted',
  },
  successNewName: {
    id: `${namespace}.successNewName`,
    nb: 'Navn endret',
    en: 'New name saved',
  },
  newRequirementModalTitle: {
    id: `${namespace}.newRequirementModalTitle`,
    nb: 'Opprett nytt aktivitetskrav',
    en: 'Create new requirement',
  },
  newRequirementModalConfirm: {
    id: `${namespace}.newRequirementModalConfirm`,
    nb: 'Opprett',
    en: 'Create',
  },
  newRequirementNameModalTitle: {
    id: `${namespace}.newRequirementNameModalTitle`,
    nb: 'Endre navn',
    en: 'Change name',
  },
  newRequirementNameModalConfirm: {
    id: `${namespace}.newRequirementNameModalConfirm`,
    nb: 'Lagre',
    en: 'Save',
  },
  noRequirementChosenLabel: {
    id: `${namespace}.noRequirementChosenLabel`,
    nb: 'Ingen aktivitetskrav er valgt',
    en: 'No requirement is chosen',
  },
  noRequirementChosenText: {
    id: `${namespace}.noRequirementChosenText`,
    nb: 'Opprett et nytt, eller velg fra menyen over.',
    en: 'Create a new one, or choose from the menu above.',
  },
};

export default translations;
